import { Vue } from 'vue-property-decorator'
import Usuario from 'higia-lib-components/src/lib-components/domains/user.dto'
import keycloackService from '@/services/keycloak.service'
import api from '@/servicesTS/higia-api-provider.service'
import store from '@/store'
import moment from '@/plugins/moment'
import HigiaPrivilegioService from '@/servicesTS/HigiaPrivilegiosSevice'
import HigiaComunicationSevice from 'higia-lib-components/src/lib-components/services/higia-comunication.service'
import HigiaStorageService from 'higia-lib-components/src/lib-components/services/higia-storage.service'

export default class HigiaAuthService extends Vue {
    higiaPrivilegioService: HigiaPrivilegioService
    higiaComunicationSevice: HigiaComunicationSevice
    higiaStorageService: HigiaStorageService

    constructor() {
        super()
        this.higiaStorageService = new HigiaStorageService()
        this.higiaPrivilegioService = new HigiaPrivilegioService()
        this.higiaComunicationSevice = new HigiaComunicationSevice()
    }

    public authenticate = (login: any, senha: any, mode: any) => {
        const data = {
            user: login,
            password: senha,
            mode: mode,
        }
        return api.apiProvider.post('/authenticate', data)
    }

    public clearSession(callback: any) {
        sessionStorage.clear()
        localStorage.clear()
        Usuario.createUsuario()
        if (typeof callback == 'function') {
            callback()
        }
    }

    public refreshToken() {
        const data = {
            refreshToken: keycloackService.getRefreshToken(),
        }
        return api.apiProvider.post('/authenticate/refresh', data)
    }

    /*tokenIsExpired() {
        const sessionTime = this.getSessionTime();
        if(sessionTime == null) {
            return true;
        }
        if((sessionTime +2) > store.getters.auth.expires.expires_in){
            return true;
        }
        return false;
    }*/

    getSessionTime() {
        const auth = store.getters.auth
        const dateTime = auth ? moment(auth.dateTime) : null
        if (dateTime == null) {
            return null
        }
        const dateTimeDiff = moment(moment().diff(dateTime))
        const duration = dateTimeDiff.valueOf() / 1000
        return duration
    }

    public authorized = (data: any, callback?: Function) => {
        keycloackService.saveToken(data.payload.access_token)
        keycloackService.saveRefreshToken(data.payload.refresh_token)
        const dataTemporal = new Date().toISOString()
        this.higiaStorageService.set('date_time', dataTemporal)
        this.higiaStorageService.set('token_time', dataTemporal)
        this.higiaStorageService.set('expires_in', data.payload.expires_in)
        this.higiaStorageService.set('refresh_expires_in', data.payload.refresh_expires_in)
        if (data.grantedAuthorities && data.grantedAuthorities.length) {
            //TODO verificar linha
            this.higiaPrivilegioService.setPrivilegios(data.grantedAuthorities)
        }
        setTimeout(function () {
            if (typeof callback == 'function') {
                callback()
            }
        })
    }

    sessionIsExpired() {
        const sessionTime = this.getSessionTime()
        if (sessionTime == null) {
            return true
        }
        if (sessionTime > store.getters.auth.expires.refresh_expires_in) {
            return true
        }
        return false
    }

    public isAuthenticated = () => {
        return store.getters.isAuthenticated
    }

    public getUser = () => {
        return store.getters.auth.user
    }

    public _getSessionTime = () => {
        const auth = store.getters.auth
        const dateTime = auth ? moment(auth.dateTime) : null
        if (dateTime == null) {
            return null
        }
        const dateTimeDiff = moment(moment().diff(dateTime))
        const duration = dateTimeDiff.valueOf() / 1000
        return duration
    }
}
